import React from "react";


import SpecialGoodyear from "../../common/SpecialGoodyear";
import EmptyArticle from "../../common/EmptyArticle";

const ASpecialGoodyear = props => {
    let article = EmptyArticle();
    const { settings } = props;
    article.link = settings.link;
    article.img = settings.img;
    article.title = settings.title;
    article.embed = settings.embed;
    article.description = settings.description;

    return (
        <div className={props.classes} {...props.events} >
            <SpecialGoodyear
                article={article}
                {...props}
            />
        </div>
    );
};


export default ASpecialGoodyear;
